"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNachweisOfflineStatus = findNachweisOfflineStatus;
exports.isConfirmed = isConfirmed;
exports.isDraft = isDraft;
exports.isDraftOrRejected = isDraftOrRejected;
exports.isReadonly = isReadonly;
exports.isRejected = isRejected;
exports.isSubmitted = isSubmitted;
exports.isSubmittedOrConfirmed = isSubmittedOrConfirmed;
exports.isVisibleForVerifier = isVisibleForVerifier;
exports.nachweisHasOfflineData = nachweisHasOfflineData;
exports.statusTypes = void 0;
exports.tateigkeitHasOfflineData = tateigkeitHasOfflineData;
var statusTypes = exports.statusTypes = {
  entwurf: 'draft',
  eingereicht: 'submitted',
  freigegeben: 'confirmed',
  abgelehnt: 'rejected',
  // german words included for backwards compatibility
  draft: 'draft',
  submitted: 'submitted',
  confirmed: 'confirmed',
  rejected: 'rejected',
  "new": 'new',
  pending: 'pending',
  undefined: 'undefined'
};
function isDraftOrRejected(status) {
  return status === statusTypes.draft || status === statusTypes.rejected;
}
function isSubmittedOrConfirmed(status) {
  return isSubmitted(status) || isConfirmed(status);
}
function isDraft(status) {
  return status === statusTypes.draft;
}
function isSubmitted(status) {
  return status === statusTypes.eingereicht;
}
function isVisibleForVerifier(status) {
  return isReadonly(status) || isRejected(status);
}
function isReadonly(status) {
  return status === statusTypes.eingereicht || status === statusTypes.freigegeben;
}
function isRejected(status) {
  return status === statusTypes.rejected;
}
function isConfirmed(status) {
  return status === statusTypes.confirmed;
}
function tateigkeitHasOfflineData(nachweisMode, taetigkeitStatus) {
  return nachweisMode === 'offline' || taetigkeitStatus === 'new' || taetigkeitStatus === 'updated' || taetigkeitStatus === 'deleted';
}
function nachweisHasOfflineData(nachweis) {
  var taetigkeitenWithOfflineData;
  if (!nachweis) {
    return false;
  }
  if (nachweis.taetigkeiten) {
    taetigkeitenWithOfflineData = nachweis.taetigkeiten.some(function (taetigkeit) {
      return taetigkeit.status === 'new' || taetigkeit.status === 'updated' || taetigkeit.status === 'deleted';
    });
  } else {
    taetigkeitenWithOfflineData = false;
  }
  return nachweis.mode === 'offline' || taetigkeitenWithOfflineData;
}
function findNachweisOfflineStatus(nachweise, nachweisId) {
  var currentNachweis = nachweise.find(function (nachweis) {
    return nachweis.id === nachweisId;
  });
  return nachweisHasOfflineData(currentNachweis);
}